<div class="action-row d-flex justify-content-end gap-2" *ngIf="selectedTab === 'Parent' || selectedTab === 'Child'">
    <button mat-button mat-raised-button [disabled]="!activeAdd" (click)="openDialog('Add')" class="flex-item" style="margin-right: auto">Add {{ selectedTab }}</button>
    <button mat-button mat-raised-button [disabled]="!activeChange" (click)="openDialog('Change')" class="flex-item">Change {{ selectedTab }}</button>
    <button mat-button mat-raised-button [disabled]="!activeRemove" (click)="openDialog('Remove')" class="flex-item">Remove {{ selectedTab }}</button>
</div>

<div class="action-row d-flex justify-content-end gap-2" *ngIf="selectedTab === 'Match'">
    <button mat-button mat-raised-button (click)="openDialog('Reassign')" class="flex-item">Reassign</button>
</div>

<div class="action-row d-flex justify-content-end gap-2" *ngIf="selectedTab === 'Merge'">
    <button mat-button mat-raised-button (click)="openDialog('Return Survivorship')">Return Survivorship</button>
    <button mat-button mat-raised-button (click)="openDialog('Override History')">Override History</button>
</div>
